export default class NavigationDesktop {
  constructor($el) {
    this.$el = $el;
    this.$mainLinks = this.$el.querySelectorAll('.navigation__link--main[aria-controls]');
    this.$sublevels = this.$el.querySelectorAll('.navigation__sublevel');
    this.$subLinks = this.$el.querySelectorAll('.navigation__link:not(.navigation__link--main)[aria-controls]');
    this.$sublevelClose = this.$el.querySelectorAll('.navigation__sublevel-close');
    this.timer = null;
    this.timer2 = null;
    this.$currentLink = null;

    this.options = {
      submenuClass: 'navigation__level',
      submenuOpenClass: 'navigation__level--open',
      sublevelClass: 'navigation__sublevel',
      sublevelOpenClass: 'navigation__sublevel--open',
      linkClass: 'navigation__link',
      mainItemClass: 'navigation__item--main',
      mainLinkClass: 'navigation__link--main',
      navActiveClass: 'navigation--active',
      submenuCloseClass: 'navigation__level-close',
      sublevelCloseClass: 'navigation__level-close',
      navHoverTimeout250: 250,
      navHoverTimeout350: 350,
    };
  }

  init() {
    this.$mainLinks.forEach(($link) => {
      $link.parentNode.addEventListener('mouseenter', this.enter);
      $link.parentNode.addEventListener('mouseleave', this.leave);
      $link.addEventListener('focus', this.focus);
      const controls = $link.getAttribute('aria-controls');
      const levelClose = document.getElementById(controls).querySelector(`.${this.options.submenuCloseClass}`);
      levelClose.addEventListener('click', this.leave);
    });

    this.$subLinks.forEach(($link) => {
      $link.addEventListener('click', this.open);
    });

    this.$sublevelClose.forEach(($close) => {
      $close.addEventListener('click', this.close);
    });

    this.$el.addEventListener('mouseenter', this.navEnter);
    this.$el.addEventListener('mouseleave', this.navLeave);
    this.$el.addEventListener('focus', this.navEnter);
    this.$el.addEventListener('blur', this.navLeave);
  }

  deInit() {
    this.$mainLinks.forEach(($link) => {
      $link.parentNode.removeEventListener('mouseenter', this.enter);
      $link.parentNode.removeEventListener('mouseleave', this.leave);
      $link.removeEventListener('focus', this.focus);
      const controls = $link.getAttribute('aria-controls');
      const levelClose = document.getElementById(controls).querySelector(`.${this.options.submenuCloseClass}`);
      levelClose.removeEventListener('click', this.leave);
    });

    this.$subLinks.forEach(($link) => {
      $link.removeEventListener('click', this.open);
    });

    this.$sublevelClose.forEach(($close) => {
      $close.removeEventListener('click', this.close);
    });

    this.$el.removeEventListener('mouseenter', this.navEnter);
    this.$el.removeEventListener('mouseleave', this.navLeave);
    this.$el.removeEventListener('focus', this.navEnter);
    this.$el.removeEventListener('blur', this.navLeave);
  }

  navEnter = () => {
    clearTimeout(this.timer2);
    this.timer2 = setTimeout(() => {
      this.$el.classList.add(this.options.navActiveClass);
    }, this.options.navHoverTimeout250);
  };

  enter = (event) => {
    const $target = event.currentTarget;
    const $targetLink = $target.querySelector(`.${this.options.mainLinkClass}`);
    this.$currentLink = $targetLink;
    clearTimeout(this.timer);

    if ($targetLink) {
      const controls = $targetLink.getAttribute('aria-controls');
      const $submenu = document.getElementById(controls);
      this.closeSubMenus();

      if ($submenu) {
        this.timer = setTimeout(() => {
          $targetLink.setAttribute('aria-expanded', 'true');
          $submenu.classList.add(this.options.submenuOpenClass);
        }, this.options.navHoverTimeout250);
      }
    }
  }

  open = (event) => {
    const $target = event.currentTarget;

    if ($target) {
      const controls = $target.getAttribute('aria-controls');
      const $submenu = document.getElementById(controls);

      if ($submenu) {
        this.$sublevels.forEach(($subLevel) => {
          const $el = $subLevel;
          $el.removeAttribute('style');
        });

        const $closestLevelContent = $target.closest('.navigation__level-content-inner');
        $closestLevelContent.removeAttribute('style');

        const levelContentSize = $closestLevelContent.getBoundingClientRect();
        const submenuContentSize = $submenu.getBoundingClientRect();
        const targetHeight = Math.max(levelContentSize.height, submenuContentSize.height);

        if (submenuContentSize.height > levelContentSize.height) {
          $closestLevelContent.style.height = `${submenuContentSize.height + 40}px`;
        }

        this.$sublevels.forEach(($subLevel) => {
          const $el = $subLevel;
          $el.style.width = `${levelContentSize.width}px`;
          $el.style.height = `${targetHeight + 40}px`;
        });

        $target.setAttribute('aria-expanded', 'true');
        $submenu.classList.add(this.options.sublevelOpenClass);
      }
    }
  }

  navLeave = () => {
    clearTimeout(this.timer2);
    this.timer2 = setTimeout(() => {
      this.$el.classList.remove(this.options.navActiveClass);

      this.$mainLinks.forEach(($mainLink) => {
        $mainLink.setAttribute('aria-expanded', 'false');
      });
    }, this.options.navHoverTimeout250);
  };

  leave = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.$el
        .querySelectorAll(`.${this.options.submenuOpenClass}`)
        .forEach(($sub) => {
          $sub.classList.remove(this.options.submenuOpenClass);

          if (this.$currentLink) {
            this.$currentLink.setAttribute('aria-expanded', 'false');
          }
        });
    }, this.options.navHoverTimeout250);
  };

  close = (event) => {
    const $target = event.currentTarget;
    const controls = $target.getAttribute('aria-controls');

    if (controls) {
      const $submenu = document.getElementById(controls);
      const $submenuLink = this.$el.querySelector(`[aria-controls=${controls}]`);
      if ($submenu) {
        this.$sublevels.forEach(($subLevel) => {
          const $el = $subLevel;
          $el.removeAttribute('style');
        });

        const $closestLevelContent = $target.closest('.navigation__level-content-inner');
        $closestLevelContent.removeAttribute('style');

        $submenuLink.setAttribute('aria-expanded', 'false');
        $submenu.classList.remove(this.options.sublevelOpenClass);

        // Find the remaining sublevel that's opened
        const $openedSublevel = this.$el.querySelector('.navigation__sublevel--open');

        if ($openedSublevel) {
          const levelContentSize = $closestLevelContent.getBoundingClientRect();
          const submenuContentSize = $openedSublevel.getBoundingClientRect();
          const targetHeight = Math.max(levelContentSize.height, submenuContentSize.height);

          if (submenuContentSize.height > levelContentSize.height) {
            $closestLevelContent.style.height = `${submenuContentSize.height + 40}px`;
          }

          this.$sublevels.forEach(($subLevel) => {
            const $el = $subLevel;
            $el.style.width = `${levelContentSize.width}px`;
            $el.style.height = `${targetHeight + 40}px`;
          });
        }
      }
    }
  }

  focus = (event) => {
    const $target = event.currentTarget;

    this.$el
      .querySelectorAll(`.${this.options.submenuOpenClass}`)
      .forEach(($sub) => {
        $sub.classList.remove(this.options.submenuOpenClass);
      });

    if ($target) {
      const $submenu = $target
        .closest(`.${this.options.mainItemClass}`)
        .querySelector(`.${this.options.submenuClass}`);

      if ($submenu) {
        $submenu.classList.add(this.options.submenuOpenClass);
      }
    }
  }

  closeSubMenus() {
    const openMenus = Array.from(this.$el.querySelectorAll(`.${this.options.submenuOpenClass}`));
    const openMenuLinks = openMenus.map(m => m.previousElementSibling);

    openMenus.forEach($menu => $menu.classList.remove(this.options.submenuOpenClass));
    openMenuLinks.forEach(($link) => {
      $link.setAttribute('aria-expanded', 'false');
    });
  }
}
